import moment from "moment";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";

export const getProcedureList = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem("id_token"),
    },
  });

  if (res?.data?.statusCode === 200) {
    if (res?.data?.procedure_list?.length > 0) {
      res.data.procedure_list.map((ele) => {
        ele["value"] = ele?.procedure_id
          ? ele?.procedure_id
          : ele?.consultation_type;
        ele["label"] = ele?.procedure_name;
      });
      return [res.data.procedure_list, false];
    } else {
      return [[], false];
    }
  }
  return [null, true]; // [response, error]
};

export const getScheduledTime = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem("id_token"),
    },
  });
  if (res?.data?.statusCode === 200) {
    if (res?.data?.schedules?.length > 0) {
      let hasDelay = res.data.schedules.filter((data) => data?.status);
      res.data.schedules.forEach((element) => {
        element["start_hr"] = moment(element?.start_time, "hh:mm:ssZ").format(
          "hh"
        );
        element["start_min"] = moment(element?.start_time, "hh:mm:ssZ").format(
          "mm"
        );
        element["start_meridiem"] = moment(
          element?.start_time,
          "hh:mm:ssZ"
        ).format("A");
        element["end_hr"] = moment(element?.end_time, "hh:mm:ssZ").format("hh");

        element["end_min"] = moment(element?.end_time, "hh:mm:ssZ").format(
          "mm"
        );

        element["end_meridiem"] = moment(element?.end_time, "hh:mm:ssZ").format(
          "A"
        );
        element["showRadioBtn"] = res.data.schedules.length > 1 ? true : false;
        element["checked"] = res.data.schedules.length > 1 ? false : true;

        element["temp_start_hr"] = moment(
          element?.start_time,
          "hh:mm:ssZ"
        ).format("hh");
        element["temp_start_min"] = moment(
          element?.start_time,
          "hh:mm:ssZ"
        ).format("mm");
        element["temp_start_meridiem"] = moment(
          element?.start_time,
          "hh:mm:ssZ"
        ).format("A");
        element["temp_end_hr"] = moment(element?.end_time, "hh:mm:ssZ").format(
          "hh"
        );

        element["temp_end_min"] = moment(element?.end_time, "hh:mm:ssZ").format(
          "mm"
        );

        element["temp_end_meridiem"] = moment(
          element?.end_time,
          "hh:mm:ssZ"
        ).format("A");
        element["start_time"] = moment(element?.start_time, "hh:mm:ssZ").format(
          "hh:mm A"
        );
        element["end_time"] = moment(element?.end_time, "hh:mm:ssZ").format(
          "hh:mm A"
        );
        element["start_message"] = "";
        element["end_message"] = "";
        element["hasStartError"] = false;
        element["hasEndError"] = false;
        element["original_start_time"] = element?.original_start_time
          ? moment(element?.original_start_time, "hh:mm:ssZ").format("hh:mm A")
          : moment(element?.start_time, "hh:mm:ssZ").format("hh:mm A");
        element["original_end_time"] = element?.original_end_time
          ? moment(element?.original_end_time, "hh:mm:ssZ").format("hh:mm A")
          : moment(element?.end_time, "hh:mm:ssZ").format("hh:mm A");
        element["showTick"] = hasDelay?.length > 0 ? true : false;
      });
      res.data.schedules[0].checked = true;
      return [res.data.schedules, false];
    } else {
      return [[], false];
    }
  }
  return [null, true]; // [response, error]
};
